module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_14.4a9373e9.png";